<template>
  <div
    ref="headerTopContainer"
    :class="{
      'header-top-fi': true,
      'header-top-fi--search-active': isSearchActive,
      'header-top-fi--ssr': notMounted,
      'header-top-fi--large-logo': largeLogo && !isUpat,
      'header-top-fi--upat': isUpat,
    }"
  >
    <assisted-service-module-fi />
    <handling-fee-limit-banner-fi :handling-fee-limit="handlingFeeLimit" />

    <div class="header-top-fi__container">
      <div class="header-top-fi__left">
        <a
          v-if="logoHeader?.src && homeData"
          :href="homeData.url"
          :title="homeData.title"
          class="header-top-fi__logo"
        >
          <logo-header-fi
            :logo-header="logoHeader"
            :large="$fischer.largeLogo()"
          />
        </a>

        <div class="header-top-fi__navigation">
          <navigation-bar-fi
            class="header-top-fi__navigation-bar"
            :navigation-data="navigationData"
            :service-navigation="serviceNavigation"
            @login="$emit('login')"
          />
          <mobile-navigation-bar-fi
            :service-navigation="serviceNavigation"
            class="header-top-fi__mobile-navigation-bar"
            @login="$emit('login')"
          />
        </div>
      </div>

      <div class="header-top-fi__right">
        <search-box-fi
          id="search-box-header-top"
          is-desktop
          @clear="closeHistory"
        />
        <search-history-fi
          ref="history"
          lg
        />
      </div>
    </div>

    <template v-if="jumpMarks?.length">
      <jump-mark-tabs-fi
        v-show="!showFlyout"
        ref="jumpMarkTabs"
      />
    </template>

    <snackbar-fi
      v-if="
        $fischer.shop.isClosedShop() ||
        $fischer.shop.isOnlineShop() ||
        $fischer.shop.isRetailConnectCart()
      "
    />
  </div>
</template>

<script setup lang="ts">
import { LogoHeaderFi } from 'atoms';
import { computed, onMounted, ref, useTemplateRef } from 'vue';

import AssistedServiceModuleFi from '@/components/assisted-service-module-fi/AssistedServiceModuleFi.vue';
import HandlingFeeLimitBannerFi from '@/components/handling-fee-limit-banner-fi/HandlingFeeLimitBannerFi.vue';
import MobileNavigationBarFi from '@/components/header-fi/header-top-fi/mobile-navigation-bar-fi/MobileNavigationBarFi.vue';
import NavigationBarFi from '@/components/header-fi/header-top-fi/navigation-bar-fi/NavigationBarFi.vue';
import JumpMarkTabsFi from '@/components/jump-mark-tabs-fi/JumpMarkTabsFi.vue';
import SearchBoxFi from '@/components/search/search-box-fi/SearchBoxFi.vue';
import SearchHistoryFi from '@/components/search/search-history-fi/SearchHistoryFi.vue';
import SnackbarFi from '@/components/shop-modules/snackbar-fi/SnackbarFi.vue';
import { useFischer } from '@/composables/fischerPlugin';
import { useHeader } from '@/composables/header';
import type { ImageFieldValue } from '@/sitecoreFieldTypes';
import { useNavigationStore } from '@/store/pinia/navigation';

defineOptions({
  name: 'HeaderTopFi',
});

withDefaults(
  defineProps<{
    handlingFeeLimit?: string | null;
    logoHeader?: ImageFieldValue;
    homeData?: any;
    navigationData?: any[];
    serviceNavigation: any[];
  }>(),
  {
    handlingFeeLimit: null,
    logoHeader: () => ({}),
    homeData: () => ({}),
    navigationData: () => [],
  },
);

defineEmits<{
  login: [value: void];
}>();

const headerRef = useTemplateRef<HTMLDivElement>('headerTopContainer');
const history = useTemplateRef('history');

const navigationStore = useNavigationStore();
const fischer = useFischer();
useHeader(headerRef);

const notMounted = ref<boolean>(true);
onMounted(() => {
  notMounted.value = false;
});

const showFlyout = computed<boolean>(() => navigationStore.showFlyout);
const isSearchActive = computed<boolean>(() => navigationStore.searchActive);
const jumpMarks = computed<any[]>(() => navigationStore.jumpMarks);

const largeLogo = computed<boolean>(() => fischer.largeLogo());

const closeHistory = () => history.value?.close();
</script>

<style scoped src="./header-top-fi" />
